import React, { useState, useRef, useEffect } from 'react'
import ReactDOM from 'react-dom'
import { MDBIcon } from 'mdb-react-ui-kit'
import { toast } from 'react-toastify'
import AvService from '../../../../shared/services/Av.service'

const AV_STATUSES = [
  { text: 'Issued', value: 'Issued' },
  { text: 'Submitted', value: 'Submitted' },
  { text: 'Transferred', value: 'Transferred' },
  { text: 'Transfer (w Pts)', value: 'Transfer w Pts' },
  { text: 'Withdrawn', value: 'Withdrawn' },
  { text: 'Declined', value: 'Declined' },
  { text: 'Cancelled', value: 'Cancelled' },
]

const AvStatusSelector = ({ avId, avStatus }) => {
  const [isUpdating, setIsUpdating] = useState(false)
  const [updatedStatus, setUpdatedStatus] = useState(null)
  const [isOpen, setIsOpen] = useState(false)
  const [position, setPosition] = useState({ top: 0, left: 0, width: 0 })
  const triggerRef = useRef(null)
  const dropdownRef = useRef(null)

  const classes = [`av_status_${avId}`, avStatus ? `av-status-${avStatus}` : null].filter(n => n).join(' ')
  const currentStatus = updatedStatus || avStatus

  // Update position when dropdown opens or on scroll/resize
  useEffect(() => {
    const updatePosition = () => {
      if (triggerRef.current) {
        const rect = triggerRef.current.getBoundingClientRect()
        setPosition({
          top: rect.bottom + window.scrollY,
          left: rect.left + window.scrollX,
          width: rect.width,
        })
      }
    }

    if (isOpen) {
      updatePosition()
      window.addEventListener('scroll', updatePosition, true)
      window.addEventListener('resize', updatePosition)

      return () => {
        window.removeEventListener('scroll', updatePosition, true)
        window.removeEventListener('resize', updatePosition)
      }
    }
  }, [isOpen])

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = event => {
      if (
        triggerRef.current &&
        !triggerRef.current.contains(event.target) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false)
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
      return () => document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpen])

  const updateStatus = async newStatus => {
    if (newStatus && newStatus !== currentStatus) {
      setIsOpen(false)
      setIsUpdating(true)
      try {
        const AV = await AvService.get(avId)
        if (AV) {
          AV.av_status = newStatus
          const res = await AvService.update(avId, AV)
          if (res?.error) toast.error(res.error, { position: toast.POSITION.TOP_CENTER })
          else setUpdatedStatus(newStatus)
        }
      } catch (ex) {
        console.log(`${ex}`)
      }
      setIsUpdating(false)
    }
  }

  return (
    <>
      <div className={`AvStatusSelectorComponent ${classes} ${isUpdating ? 'is-updating' : ''}`} ref={triggerRef}>
        {isUpdating ? (
          <div className='status-loading'>
            <i className='fa fa-spin fa-spinner fa-spinning'></i>&nbsp;Saving...
          </div>
        ) : (
          <div className='status-selector-trigger' onClick={() => setIsOpen(!isOpen)}>
            <span>
              {AV_STATUSES.find(s => s.value.toLowerCase() === `${currentStatus}`.toLowerCase())?.text ||
                currentStatus ||
                'Select Status'}
            </span>
            <MDBIcon fas icon={isOpen ? 'caret-up' : 'caret-down'} />
          </div>
        )}
      </div>

      {isOpen &&
        ReactDOM.createPortal(
          <ul
            ref={dropdownRef}
            className='av-status-selector-dropdown-menu'
            style={{
              top: `${position.top}px`,
              left: `${position.left}px`,
              width: `${position.width}px`,
            }}
          >
            {AV_STATUSES.map(status => (
              <li
                key={status.value}
                onClick={() => updateStatus(status.value)}
                className={currentStatus === status.value ? 'selected' : ''}
                onMouseEnter={e => (e.target.style.backgroundColor = '#f5f5f5')}
                onMouseLeave={e =>
                  (e.target.style.backgroundColor = currentStatus === status.value ? '#f0f0f0' : 'transparent')
                }
              >
                {status.text}
              </li>
            ))}
          </ul>,
          document.body
        )}
    </>
  )
}

export default AvStatusSelector
